import { absoluteUrl } from '@/lib/site';

/**
 * robots.txt.
 *
 * Written as a route rather than a static file so the sitemap URL comes
 * from PUBLIC_BASE_URL rather than being hardcoded to one domain.
 */
export const revalidate = 86400;

export function GET(): Response {
  const body = [
    'User-agent: *',
    'Allow: /',
    '',
    '# Internal build view, not content.',
    'Disallow: /en/status',
    'Disallow: /ar/status',
    'Disallow: /admin',
    '',
    `Sitemap: ${absoluteUrl('/sitemap.xml')}`,
    '',
  ].join('\n');

  return new Response(body, {
    headers: {
      'content-type': 'text/plain; charset=utf-8',
      'cache-control': 'public, max-age=86400',
    },
  });
}
